<template>
  <div>
    <div class="export_result_header">
      <div class="prompt-text"><i class="icon el-icon-warning"></i>仅显示3个月内的导入记录
      </div>
      <el-button
          class="btn-form-inline"
          type="primary"
          size="small"
          @click="init"
      >刷新
      </el-button>
    </div>
    <!-- 列表 -->
    <el-table :data="tableList" height="360" stripe border class="table-list">
      <el-table-column label="操作人" prop="createUserName" min-width="80" align="center"></el-table-column>
      <el-table-column label="操作时间" min-width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | formatDay }}</span>
        </template>
      </el-table-column>
      <el-table-column label="导入路径" prop="typeName" min-width="200" align="center"
                       show-overflow-tooltip></el-table-column>
      <el-table-column label="文件名" prop="fileUrl" min-width="200" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <a :href="scope.row.fileUrl" target="_blank" :style="{ color: 'blue' }">{{ scope.row.fileName }}</a>
        </template>
      </el-table-column>
      <el-table-column label="时长" min-width="60" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.rt | formatSeconds }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="failReason" min-width="320" align="center"
                       show-overflow-tooltip></el-table-column>
      <el-table-column label="状态" prop="statusDescription" min-width="60" align="center"></el-table-column>
    </el-table>

    <div style="text-align: right; margin-top: 15px;">
      <el-pagination @current-change="handleCurrentChange" :page-size="paginationConf.pageSize"
                     :current-page.sync="paginationConf.pageNo" background
                     layout="total, prev, pager, next" :total="paginationConf.pageTotal">
      </el-pagination>
    </div>
  </div>
</template>
<script>

import Moment from "moment";

export default {
  name: "importTab",
  data() {
    return {
      selectList: [],
      tableList: [],
      paginationConf: {
        way:2,
        pageNo: 0,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.paginationConf.pageNo = 1;
    this.init();
  },
  filters: {
    formatDay(time) {
      return time ? Moment(time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    formatSeconds(value) {
      if (!value && value!==0) return '';

      let seconds = parseInt(value, 10);

      let minutes = Math.floor(seconds / 60);

      seconds = seconds % 60;

      minutes = minutes < 10 ? '0' + minutes : minutes;

      seconds = seconds < 10 ? '0' + seconds : seconds;
      if (minutes === '00') {
        return seconds + '秒';
      } else {
        return minutes + '分' + seconds + '秒';
      }
    },
  },
  methods: {
    async init() {
      let res = await this.$api.queryExcelImportExportHistory(this.paginationConf);
      if (res.code === 200) {
        this.tableList = res.result.list;
        this.paginationConf.pageTotal = res.result.totalCount;
      }
    },
    handleCurrentChange(val) {
      this.paginationConf.pageNo = val;
      this.init();
    },
  },
};
</script>
<style lang="less" scoped>
h3 {
  margin-top: 20px;
}

/deep/ .el-dialog__title {
  font-weight: 900;
}

/deep/ .reset .el-form-item__content {
  width: calc(100% - 100px);
}

.export_result_header {
  line-height: 20px;
  margin-right: 30px
}

.export_result_header .btn-form-inline {
  float: right;
}

.billDetail-content {
  width: 360px;
  line-height: 20px;
  float: right;
  margin: 10px 0;
  padding: 0 15px;
  background-color: #ecf4ff;

  .item {
    padding: 5px 0;
    text-align: right;

    .label {
      width: 160px;
      float: left;
    }

    .value {
      width: calc(100% - 160px);
      float: left;
      font-weight: bold;
    }
  }

  .billDetail-content-buyer {
    padding: 10px 0;
  }

  .billDetail-content-price {
    border-top: 1px solid #666;
    padding: 10px 0;
  }
}

.billDetail-form {
  width: 510px;
  float: right;
}

.prompt-text {
  display: inline-block;
  min-height: 30px;
  line-height: 30px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  padding: 0 15px;
  vertical-align: top;

  .icon {
    font-size: 16px;
    color: #FAAD14;
    margin-right: 5px;
    vertical-align: middle;
    margin-top: -2px;
  }

  .custom-link {
    color: #003cff;
  }
}
</style>
